const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 84 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#456493",
    id: "Path_639",
    d: "M11.497,3.716L10.848,6.594C10.811,6.948 10.662,8.14 11.845,8.595C11.938,8.631 12.384,8.637 12.484,8.637L18.325,8.637L18.33,10.097L15.701,16.38L7.266,16.363C7.166,16.363 6.592,15.839 6.592,15.739L6.584,7.705L11.781,2.416M12,0L5.6,6.4C5.2,6.8 5,7.3 5,7.8L5,15.7C5,17 6,18 7.3,18L15.4,18C16.1,18 16.8,17.6 17.2,17L19.8,10.9C19.9,10.6 20,10.4 20,10.1L20,9C20,7.9 19.1,7 18,7L12.5,7L13.4,2.4C13.4,2.2 13.4,1.9 13.3,1.7C13.1,1.2 12.8,0.8 12.4,0.5L12,0ZM2,7L0,7L0,18L2,18C2.6,18 3,17.6 3,17L3,8C3,7.4 2.6,7 2,7Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpBlue);
export default __webpack_public_path__ + "static/media/ThumbsUpBlue.eabe6962ad8bc5e13572d077de35c98b.svg";
export { ForwardRef as ReactComponent };